<template>
    <div class="job-index">
        <div class="job-header flex-center">
            <div class="header-left flex-center">
                <span class="recommend">推荐</span>

                <div class="split-line"></div>

                <div class="add-expect flex-center">
                    <div class="add-icon flex-center">
                        <i class="el-icon-plus"></i>
                    </div>
                    <span @click="handleToExpect">添加求职期望</span>
                </div>
            </div>

            <div class="header-right">
                <el-input v-model="filter.keyword" placeholder="搜索职位、公司" clearable @keydown.enter.native="getJobList">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>

                <button class="search-btn flex-center" type="button" @click="getJobList">搜索</button>
            </div>
        </div>

        <div class="job-box">
            <div class="filter-box flex-center">
                <FilterConfigs ref="filterConfigsRef" @change="handleFilterChange"></FilterConfigs>

                <span class="filter-clear" @click="handleClearFilter">清空</span>
            </div>

            <div class="box-main" v-if="jobList.length > 0">
                <div class="job-list">
                    <RecCompanyList :company="companyInfo" style="margin-bottom: 16px" v-if="companyInfo"></RecCompanyList>

                    <RecJobList
                        :list="jobList"
                        :check="currentJob"
                        :isCompany="true"
                        @change="
                            ($event) => {
                                currentJob = $event;
                                getJobDetail(currentJob);
                            }
                        "
                    ></RecJobList>

                    <div class="pagination flex-center">
                        <el-pagination
                            @current-change="handlePageChange"
                            background
                            :page-size="pageParams.page_size"
                            layout="prev, pager, next"
                            :total="pageParams.total"
                        >
                        </el-pagination>
                    </div>
                </div>

                <div class="job-detail" v-if="!!jobDetail">
                    <RecJobOverview :job="jobDetail" @apply="handleApply" @more="toMore"></RecJobOverview>
                </div>

                <div class="job-detail-empty" v-else>
                    <div class="empty-header flex-center">
                        <div class="header-left">
                            <div class="empty-block block-1"></div>
                            <div class="empty-block block-2"></div>
                        </div>

                        <div class="empty-block"></div>
                    </div>

                    <div class="empty-content" v-for="item in 3" :key="item">
                        <div class="empty-block block-1"></div>
                        <div class="empty-block block-2"></div>
                        <div class="empty-block block-3"></div>
                    </div>
                </div>
            </div>

            <div class="empty-box flex-center" v-else>
                <img src="@/assets/img/company/job-empty.png" alt="" />

                <span>没有找到相关职位，打开App，查看全部职职位库，优质职位随心聊。</span>
            </div>
        </div>
    </div>
</template>

<script>
import FilterConfigs from "@/components/recruitmentCenter/job/FilterConfigs.vue";
import RecJobList from "@/components/recruitmentCenter/job/RecJobList.vue";
import RecCompanyList from "@/components/recruitmentCenter/job/RecCompanyList.vue";
import RecJobOverview from "@/components/recruitmentCenter/job/RecJobOverview.vue";
import { isEmpty } from "@/utils/common.js";

export default {
    data() {
        return {
            filter: {
                keyword: this.$route.query?.keyword || "", // 搜索关键词
                city: undefined,
                job_type: undefined,
                salary: undefined,
                experience: [],
                degree: [],
                industry: [],
                staff_size: [],
            },

            pageParams: {
                page: 1,
                page_size: 5,
                total: 0,
            },

            currentJob: undefined,
            jobList: [],
            jobDetail: undefined,
            companyInfo: undefined,
        };
    },

    created() {
        this.getJobList();
    },

    computed: {
        filterParams() {
            const params = {};

            if (this.filter.keyword) params.keyword = this.filter.keyword;
            if (this.filter.city) params.city = this.filter.city;
            if (this.filter.job_type) params.job_type = this.filter.job_type;
            if (this.filter.salary) params.salary = this.filter.salary;
            if (this.filter.experience.length > 0) params.experience = this.filter.experience.join(",");
            if (this.filter.degree.length > 0) params.degree = this.filter.degree.join(",");
            if (this.filter.industry.length > 0) params.industry = this.filer.industry.join(",");
            if (this.filter.staff_size.length > 0) params.staff_size = this.filter.staff_size.join(",");

            return params;
        },
    },

    components: {
        FilterConfigs,
        RecJobList,
        RecCompanyList,
        RecJobOverview,
    },

    methods: {
        // 过滤回调
        handleFilterChange(val) {
            Object.assign(this.filter, val);

            this.getJobList();
        },

        handleClearFilter() {
            this.$refs.filterConfigsRef?.clear?.();
        },

        // 分页切换
        handlePageChange(val) {
            this.pageParams.page = val;

            this.getJobList();
        },

        // 获取职位列表
        getJobList() {
            const params = {
                page: this.pageParams.page,
                page_size: this.pageParams.page_size,
                ...this.filterParams,
            };

            this.$httpStudent.axiosGetBy(this.$api.jobPositionList, params, (res) => {
                if (res.code === 200) {
                    this.pageParams.total = res.data?.total || 0;
                    this.jobList = res.data?.list || [];
                    this.companyInfo = !isEmpty(res.data?.company_info) ? res.data?.company_info : undefined;

                    if (this.jobList.length > 0) {
                        this.currentJob = this.jobList[0].id;
                        this.getJobDetail(this.currentJob);
                    }
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        getJobDetail(id, clear = true) {
            if (clear) this.jobDetail = undefined;

            this.$httpStudent.axiosGetBy(this.$api.jobPositionDetail, { id }, (res) => {
                if (res.code === 200) {
                    this.jobDetail = res.data;
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        // 投递简历
        handleApply() {
            if (!this.currentJob) return;

            this.$httpStudent.axiosPost(this.$api.jobApplyPosition, { position_id: this.currentJob }, (res) => {
                if (res.code === 200) {
                    this.getJobDetail(this.currentJob, false);
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        toMore() {
            if (!this.currentJob) return;

            this.$router.push({
                path: "/student/recruitmentCenter/job/detail",
                query: { id: this.currentJob },
            });
        },

        handleToExpect() {
            this.$router.push({
                path: "/student/recruitmentCenter/personalResume",
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.job-index {
    padding-top: 80px;

    * {
        box-sizing: border-box;
    }

    .job-header {
        height: 80px;
        background: #302e4b;
        position: fixed;
        top: 60px;
        right: 0;
        left: 221px;
        padding-inline: 257px;
        justify-content: space-between;

        .header-left {
            gap: 20px;

            span {
                color: #ffffff;
                cursor: pointer;

                &:hover {
                    text-decoration: underline;
                }
            }

            .split-line {
                height: 14px;
                width: 2px;
                background-color: #ffffff;
            }

            .add-expect {
                .add-icon {
                    width: 20px;
                    height: 20px;
                    border-radius: 4px;
                    background-color: #ffffff;
                    margin-right: 4px;
                }
            }
        }

        .header-right {
            width: 656px;
            height: 48px;
            background: #ffffff;
            border-radius: 24px;
            border: 1px solid #685ef5;
            position: relative;
            padding-inline-start: 16px;

            ::v-deep .el-input {
                width: calc(100% - 116px);
            }

            ::v-deep .el-input__inner {
                height: 46px;
                border: none;
                // background-color: #302e4b;
                background-color: transparent;
            }

            ::v-deep .el-input__icon {
                font-size: 18px;
                line-height: 46px;
            }

            .search-btn {
                width: 96px;
                height: 40px;
                background: #685ef5;
                border-radius: 20px;
                position: absolute;
                top: 50%;
                right: 3px;
                transform: translateY(-50%);
                outline: none;
                border: none;
                font-size: 16px;
                color: #fff;
                cursor: pointer;
            }
        }
    }

    .job-box {
        padding-inline: 240px;

        .filter-box {
            justify-content: space-between;
            margin-bottom: 16px;

            .filter-clear {
                font-weight: 400;
                font-size: 14px;
                color: #414a60;
                cursor: pointer;
            }
        }

        .box-main {
            display: flex;
            gap: 16px;

            .job-list {
                width: 384px;

                .pagination {
                    margin-top: 12px;

                    ::v-deep(.el-pager) {
                        li {
                            min-width: 26px;
                            height: 26px;
                            background-color: #ffffff;
                            font-size: 12px;
                        }

                        li:hover {
                            color: #685ef5;
                        }

                        li:not(.disabled).active {
                            background-color: #685ef5;
                            color: #fff;
                        }
                    }

                    ::v-deep(.el-pagination) {
                        button {
                            min-width: 26px;
                            height: 26px;
                        }

                        button:not(.disabled) {
                            background-color: #fff;
                        }
                    }
                }
            }

            .job-detail,
            .job-detail-empty {
                flex: 1;
                min-width: 0;
                height: fit-content;
                background-color: #ffffff;
                padding: 16px 30px 20px 30px;
                border-radius: 16px;
            }

            .job-detail-empty {
                .empty-block {
                    background-color: #f2f4f7;
                    border-radius: 4px;
                    min-height: 16px;
                }

                .empty-header {
                    justify-content: space-between;

                    .header-left {
                        .empty-block.block-1 {
                            width: 300px;
                        }

                        .empty-block.block-2 {
                            width: 200px;
                            margin-top: 10px;
                        }
                    }

                    .empty-block {
                        height: 30px;
                        width: 150px;
                    }
                }

                .empty-content {
                    margin-top: 10px;
                    padding-top: 10px;
                    position: relative;

                    &::before {
                        content: "";
                        position: absolute;
                        width: 100%;
                        height: 1px;
                        top: 0;
                        left: 0;
                        background-color: #f4f6f8;
                    }

                    .empty-block + .empty-block {
                        margin-top: 8px;
                    }

                    .block-1 {
                        width: 150px;
                        height: 25px;
                    }

                    .block-2 {
                        width: 250px;
                        height: 14px;
                    }

                    .block-3 {
                        width: 100%;
                        height: 100px;
                    }
                }
            }
        }

        .empty-box {
            height: 500px;
            background-color: #ffffff;
            border-radius: 16px;
            flex-direction: column;
            gap: 16px;

            img {
                width: 200px;
                height: 117px;
                object-fit: cover;
            }

            span {
                display: inline-block;
                width: 370px;
                white-space: pre-wrap;
                text-align: center;
                color: #999;
            }
        }
    }
}
</style>
